module.exports = __webpack_public_path__ + "img/thefore.89b9215b.svg";